var _mask, _g, _path, _path2, _path3, _path4, _mask2, _g2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsup = function SvgThumbsup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "thumbsup_svg__a",
    width: 30,
    height: 30,
    x: 4,
    y: 3,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.47 3.97h28.954v28.953H4.471z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#thumbsup_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M33.424 18.446c0 7.996-6.482 14.477-14.478 14.477S4.471 26.441 4.471 18.446 10.95 3.97 18.946 3.97c7.996 0 14.478 6.481 14.478 14.476",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M25.838 22.435h-7.582a1.9 1.9 0 0 1-1.893-1.893c0-1.04.851-1.892 1.893-1.892h7.582c1.04 0 1.893.852 1.893 1.892a1.9 1.9 0 0 1-1.893 1.893",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M25.002 25.931h-6.747a1.9 1.9 0 0 1-1.892-1.893 1.9 1.9 0 0 1 1.892-1.892h6.747c1.04 0 1.892.852 1.892 1.892a1.9 1.9 0 0 1-1.892 1.893",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M24.165 29.428h-5.91a1.9 1.9 0 0 1-1.893-1.893 1.9 1.9 0 0 1 1.893-1.893h5.91c1.041 0 1.892.852 1.892 1.893a1.9 1.9 0 0 1-1.892 1.892",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M23.328 32.923h-5.072a1.9 1.9 0 0 1-1.894-1.893 1.9 1.9 0 0 1 1.894-1.893h5.072a1.9 1.9 0 0 1 1.893 1.893 1.9 1.9 0 0 1-1.893 1.893",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "thumbsup_svg__b",
    width: 7,
    height: 14,
    x: 2,
    y: 19,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 19.823h6.795v12.522H2z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#thumbsup_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M8.795 32.345H4.51A2.51 2.51 0 0 1 2 29.835V19.824h6.796z",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M15.175 9.645c1.371 0 2.482 1.1 2.506 2.466l.005 4.03a2.51 2.51 0 0 0 2.51 2.509h1.115l.105.025c3.638.848 4.244 14.248-1.617 14.248-5.864 0-11.004-.578-11.004-.578L8.78 19.822c1.097-1.545 1.338-1.93 2.71-3.3 1.092-1.093 1.174-2.385 1.174-4.367a2.51 2.51 0 0 1 2.51-2.51",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsup;